import React, {memo} from "react";
import {BookingHistoryAction} from "../../../generated/graphql";
import Tag from "../../Tag/Tag";

export const translatedAction: Record<BookingHistoryAction, {translation: string; color: string}> = {
    [BookingHistoryAction.BookingCreate]: {translation: "Buchung erstellt", color: "green"},
    [BookingHistoryAction.BookingCreateTransfer]: {translation: "Buchung erstellt (Umbuchung)", color: "green"},
    [BookingHistoryAction.BookingCreateTransferCopy]: {translation: "Buchung (Kopie)", color: "green"},
    [BookingHistoryAction.BookingCreateTransferMove]: {translation: "Buchung erstellt (Umbuchung)", color: "green"},
    [BookingHistoryAction.BookingDelete]: {translation: "Buchung gelöscht", color: "red"},
    [BookingHistoryAction.BookingDeleteTransfer]: {translation: "Buchung gelöscht (Umbuchung)", color: "red"},
    [BookingHistoryAction.WaitlistDelete]: {translation: "Wartelistenplatz gelöscht", color: "red"},
    [BookingHistoryAction.WaitlistDeleteTransfer]: {translation: "Wartelisteplatz gelöscht (Umbuchung)", color: "red"},
    [BookingHistoryAction.PlaceReservationDelete]: {translation: "Platzreservierung gelöscht", color: "red"},
    [BookingHistoryAction.WaitlistCreate]: {translation: "Warteliste erstellt", color: "lime"},
    [BookingHistoryAction.WaitlistCreateTransfer]: {translation: "Warteliste erstellt (Umbuchung)", color: "lime"},
    [BookingHistoryAction.WaitlistCreateTransferCopy]: {translation: "Warteliste erstellt (Kopie)", color: "lime"},
    [BookingHistoryAction.WaitlistCreateTransferMove]: {translation: "Warteliste erstellt (Umbuchung)", color: "lime"},
    [BookingHistoryAction.PlaceReservationCreate]: {translation: "Platzreservierung erstellt", color: "lime"},
    [BookingHistoryAction.PlaceReservationCreateByMaxAttendeesIncrease]: {
        translation: "Platzreservierung erstellt (durch Erhöhung der max. Teilnehmerzahl)",
        color: "lime",
    },
    [BookingHistoryAction.BookingOrphanDelete]: {translation: "Verwaiste Buchung gelöscht", color: "volcano"},
    [BookingHistoryAction.BookingOrphanRestore]: {translation: "Verwaiste Buchung wiederhergestellt", color: "green"},
    [BookingHistoryAction.CorrectionInvoice]: {translation: "Korrekturrechnung erstellt", color: "cyan"},
    [BookingHistoryAction.BookingSettle]: {translation: "Buchung abgerechnet", color: "orange"},
    [BookingHistoryAction.BookingCancle]: {translation: "Buchung storniert", color: "orange"},
    [BookingHistoryAction.BookingToWaitlist]: {translation: "Buchung in Warteliste umgewandelt", color: "orange"},
    [BookingHistoryAction.WaitlistToBooking]: {translation: "Warteliste in Buchung umgewandelt", color: "orange"},
    [BookingHistoryAction.WaitlistToBookingByMaxAttendeesIncrease]: {
        translation: "Von Warteliste nachgerückt (durch Erhöhung der max. Teilnehmerzahl)",
        color: "orange",
    },
    [BookingHistoryAction.PlaceReservationToBooking]: {
        translation: "Platzreservierung in Buchung umgewandelt",
        color: "orange",
    },
    [BookingHistoryAction.PriceChanged]: {translation: "Preis geändert", color: "purple"},
    [BookingHistoryAction.PaymentChanged]: {translation: "Zahlung geändert", color: "purple"},
    [BookingHistoryAction.PaymentMethodChanged]: {translation: "Zahlungsmethode geändert", color: "purple"},
    [BookingHistoryAction.ScheduledPaymentCreated]: {translation: "Zahlungsplan erstellt", color: "cyan"},
    [BookingHistoryAction.ScheduledPaymentUpdated]: {translation: "Zahlungsplan aktualisiert", color: "cyan"},
    [BookingHistoryAction.ScheduledPaymentDeleted]: {translation: "Zahlungsplan gelöscht", color: "cyan"},
    [BookingHistoryAction.ScheduledPaymentPaid]: {translation: "Zahlung als bezahlt markiert", color: "green"},
    [BookingHistoryAction.ScheduledPaymentUnpaid]: {translation: "Zahlung als unbezahlt markiert", color: "orange"},
    [BookingHistoryAction.AttendanceChanged]: {translation: "Anwesenheit geändert", color: "blue"},
    [BookingHistoryAction.LessonAdded]: {translation: "Lektion hinzugefügt", color: "green"},
    [BookingHistoryAction.LessonRemoved]: {translation: "Lektion entfernt", color: "red"},
    [BookingHistoryAction.Custom]: {translation: "Benutzerdefiniert", color: "blue"},
    [BookingHistoryAction.Created]: {translation: "Erstellt", color: "green"},
    [BookingHistoryAction.Updated]: {translation: "Aktualisiert", color: "blue"},
    [BookingHistoryAction.Canceled]: {translation: "Storniert", color: "red"},
    [BookingHistoryAction.StatusChanged]: {translation: "Status geändert", color: "blue"},
    [BookingHistoryAction.SendBookingConfirmation]: {translation: "Buchungsbestätigung versendet", color: "cyan"},
    [BookingHistoryAction.SendWaitlistConfirmation]: {translation: "Wartelistenbestätigung versendet", color: "cyan"},
    [BookingHistoryAction.SendInvoice]: {translation: "Rechnung versendet", color: "cyan"},
    [BookingHistoryAction.EmailSent]: {translation: "E-Mail versendet", color: "cyan"},
    [BookingHistoryAction.DiscountChanged]: {translation: "Rabatt geändert", color: "purple"},
    [BookingHistoryAction.MolliePaymentLinkVoided]: {translation: "Mollie-Zahlungslink entwertet", color: "orange"},
    [BookingHistoryAction.Unknown]: {translation: "Unbekannt", color: "blue"},
};

type RenderHistoryActionProps = {
    action: BookingHistoryAction | undefined;
    style?: React.CSSProperties;
};

const RenderHistoryAction = ({action, style}: RenderHistoryActionProps) => {
    if (!action) {
        return (
            <Tag style={style} color={"blue"}>
                {BookingHistoryAction.Unknown}
            </Tag>
        );
    }

    const {translation, color} = translatedAction[action];

    return (
        <Tag style={style} color={color}>
            {translation}
        </Tag>
    );
};

export default memo(RenderHistoryAction);
